"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.H1Markdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _Markdown = _interopRequireDefault(require("./Markdown"));

//
//  H1.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 12/17/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* eslint-disable filenames/match-regex */

/* Lego Toolkit */

/* Relative Imports */
var propDoc = {};
var demoProps = {};
var demoRender = "\n<H1>\n  This is an H1\n</H1>\n";

var H1 = function H1(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  var styles = useStylesheet();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, children);
};

var H1Markdown = function H1Markdown(props) {
  var className = props.className,
      style = props.style,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "style"]);
  var styles = useStylesheet();
  return /*#__PURE__*/_react["default"].createElement(_Markdown["default"], (0, _extends2["default"])({
    className: (0, _styling.css)(styles.root, className, style)
  }, otherProps));
};

exports.H1Markdown = H1Markdown;
H1.propDoc = propDoc;
H1.demoProps = demoProps;
H1.demoRender = demoRender;
var _default = H1;
exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      fonts = _useTheming.fonts,
      textBlack = _useTheming.theme.textBlack;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        fontSize: 48,
        fontFamily: fonts.bold,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.17,
        letterSpacing: "normal",
        color: textBlack
      }
    });
  }, [fonts.bold, textBlack]);
};